//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DermatomeMap_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_DermatomeMap_info.vue